<script setup lang="ts">
import { OpenJobFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'

const props = defineProps<{
  entity: OpenJobFieldsFragment
  breadcrumbs?: Link[]
}>()
</script>

<template>
  <SectionHero :entity="entity" :breadcrumbs="breadcrumbs" />
  <SectionInfoBoxes :entity="entity" />
  <Sections :entity="entity" />
</template>
